var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'entity-decoration': _vm.decorate },style:(_vm.decorationStyle)},[_vm._t("default"),_vm._v(" "),(_vm.hasOrcid)?_c('span',[_c('a',{attrs:{"target":"_blank","href":("https://orcid.org/" + (_vm.resourceData.orcid))}},[_c('img',{attrs:{"width":"16","height":"16","src":require("../assets/orcid_logo.svg")}})])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-934af1fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EntityDecorator.vue
// module id = PxRq
// module chunks = 1